import { onPageIn, onMount, onDestroy } from "@/modules/_";
import gsap from "@lib/gsap";
import { flip } from "@/utils/client-rect";
import { Scroll } from "@lib/scroll";
import { clientRect } from "@/utils/client-rect";
import CustomResize from "@/utils/custom-resize";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let isHovering = false;
  let animationFrame: number | null = null;
  let mouseX = 0;
  let mouseY = 0;
  let currentX = 0;
  let currentY = 0;
  let isVideoOpened = false;

  const lerp = (start: number, end: number, factor: number) => {
    return start + (end - start) * factor;
  };

  const headlineTextChars = element.querySelectorAll(
    ".home_hero_headline_text .char"
  );

  const paragraphTextLines = element.querySelectorAll(
    ".home_hero_pg_text .line"
  );

  const openVideo = () => {
    if (video) {
      isVideoOpened = true;
      if (window.scrollY > 0) {
        Scroll.scrollTo(0, {
          immediate: false,
          duration: 1.5,
          onComplete: () => {
            Scroll.stop();
          },
        });
      } else {
        Scroll.stop();
      }

      if (playButtonClone) {
        playButtonClone.style.opacity = "0";
        playButton.style.pointerEvents = "none";
      }
      playButton.style.opacity = "0";
      // Scroll.stop();
      isFullscreen = true;
      video.muted = false;

      if (video.paused) {
        video.play();
      }

      videoContainer.classList.add("playing");

      gsap.to(videoContainer, {
        width: "100%",
        // height: "100vh",
        borderRadius: "0px",
        duration: 1.5,
        ease: "power2.inOut",
      });

      gsap.to([heroLayout, menu], {
        opacity: 0,
        pointerEvents: "none",
        duration: 1,
        ease: "power3.out",
      });
    }

    gsap.to(closeButton, {
      opacity: 1,
      pointerEvents: "auto",
      duration: 1,
      delay: 0.7,
      ease: "power3.out",
    });
  };

  const closeVideo = () => {
    if (video && isFullscreen) {
      isVideoOpened = false;
      Scroll.start();
      isFullscreen = false;
      video.muted = true;

      gsap.to(videoContainer, {
        width: "95%",
        borderRadius: "4px",
        // height: initialHeight + "vh",
        duration: 1.5,
        ease: "power2.inOut",
      });
      videoContainer.classList.remove("playing");

      gsap.to([heroLayout, menu, playButton], {
        opacity: 1,
        pointerEvents: "auto",
        duration: 1,
        delay: 0.7,
        ease: "power3.out",
      });

      gsap.to(closeButton, {
        opacity: 0,
        pointerEvents: "none",
        duration: 1,
        ease: "power3.out",
      });
    }
  };

  const createPlayButtonClone = () => {
    playButtonClone = playButton.cloneNode(true) as HTMLElement;

    document.body.appendChild(playButtonClone);

    playButtonClone.style.position = "fixed";
    playButtonClone.style.zIndex = "9999";
    playButtonClone.style.opacity = "0";
    playButtonClone.style.transition = "opacity 0.3s ease";
    playButtonClone.style.top = "0";
    playButtonClone.style.left = "0";
    playButtonClone.style.right = "auto";
    playButtonClone.style.bottom = "auto";
    playButtonClone.style.margin = "0";
    playButtonClone.style.pointerEvents = "none";
    playButtonClone.style.transition = "left 0.6 linear, top 0.6 linear";
  };

  const animateCursor = () => {
    if (!playButtonClone || !isHovering) return;

    currentX = lerp(currentX, mouseX, 0.5);
    currentY = lerp(currentY, mouseY, 0.5);

    playButtonClone.style.left = `${currentX}px`;
    playButtonClone.style.top = `${currentY}px`;

    animationFrame = requestAnimationFrame(animateCursor);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (isVideoOpened) {
      document.body.style.cursor = "auto";
    } else {
      document.body.style.cursor = "none";
    }
    mouseX = e.clientX;
    mouseY = e.clientY;

    animateCursor();
  };

  const handleMouseEnter = (e: MouseEvent) => {
    if (!playButtonClone) return;

    if (!isVideoOpened) {
      gsap.to(playButton, {
        opacity: 0,
        pointerEvents: "none",
        duration: 0.3,
        ease: "power3.out",
      });
      playButtonClone.style.opacity = "1";
    }

    isHovering = true;
    mouseX = e.clientX;
    mouseY = e.clientY;
    currentX = mouseX;
    currentY = mouseY;

    playButtonClone.style.left = `${currentX}px`;
    playButtonClone.style.top = `${currentY}px`;

    animateCursor();
  };

  const handleMouseLeave = () => {
    if (!playButton) return;

    isHovering = false;

    document.body.style.cursor = "auto";

    if (!isVideoOpened) {
      playButtonClone.style.opacity = "0";
      gsap.to(playButton, {
        opacity: 1,
        pointerEvents: "none",
        duration: 0.3,
        ease: "power3.out",
      });
    }

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  };

  const setVideoScale = () => {
    const videoHeight = (videoWrap.offsetWidth / 16) * 9;
    const videoWrapHeight = videoWrap.offsetHeight;

    // console.log(videoWrapHeight, videoHeight);
    // account for the scale
    const videoScale = videoWrapHeight / videoHeight + 0.2;

    video?.style.setProperty("--scale", videoScale.toString());

    const timeout = setTimeout(() => {
      video?.classList.add("animate");
      clearTimeout(timeout);
    }, 100);
  };

  const cta = element.querySelector(".global_project_cta");

  const heroIcons = element.querySelectorAll(".home_hero_icon svg");

  const heroLayout = element.querySelector(".home_hero_layout");

  const menu = document.querySelector("[data-module='menu']");

  const videoContainer = element.querySelector(
    "[data-header='video']"
  ) as HTMLElement;

  const video = videoContainer.querySelector("video") as HTMLVideoElement;
  const videoWrap = videoContainer.querySelector(
    ".home_hero_vid_wrap"
  ) as HTMLElement;

  let playButtonClone: HTMLElement;

  const playButton = videoContainer?.querySelector(
    ".home_hero_media_controls"
  ) as HTMLElement;

  const pauseButton = videoContainer?.querySelector(
    ".home_hero_media_controls.is--pause"
  ) as HTMLElement;

  const closeButton = element.querySelector(".home_hero_video_close");

  const initialHeight = Math.round(
    (Number(
      getComputedStyle(videoContainer)
        .getPropertyValue("height")
        .replace("px", "")
    ) /
      window.innerHeight) *
      100
  );

  let currentIndex = 0;
  let isFullscreen = true;
  let currentTl: gsap.core.Timeline | null = null;

  onMount(() => {
    CustomResize.onWidthChange(setVideoScale);
    let isInitialized = false;

    const initializeCustomCursor = () => {
      const shouldInit =
        window.matchMedia("(pointer: fine)").matches &&
        window.matchMedia("(min-width: 1024px)").matches;

      if (shouldInit && !isInitialized) {
        createPlayButtonClone();
        videoContainer.addEventListener("mouseenter", handleMouseEnter);
        videoContainer.addEventListener("mousemove", handleMouseMove);
        videoContainer.addEventListener("mouseleave", handleMouseLeave);
        isInitialized = true;
      } else if (!shouldInit && isInitialized) {
        videoContainer.removeEventListener("mouseenter", handleMouseEnter);
        videoContainer.removeEventListener("mousemove", handleMouseMove);
        videoContainer.removeEventListener("mouseleave", handleMouseLeave);
        playButton.style.opacity = "1";
        if (playButtonClone && playButtonClone.parentElement) {
          playButtonClone.remove();
        }
        isInitialized = false;
      }
    };

    initializeCustomCursor();
    window.addEventListener("resize", initializeCustomCursor);
  });

  onPageIn(async () => {
    const tl = gsap.timeline({
      onComplete: () => {
        // startHeroIconsTl();
      },
    });
    gsap.set(element, {
      autoAlpha: 1,
    });
    tl.from(headlineTextChars, {
      xPercent: 4,
      duration: 1.2,
      ease: "power2.inOut",
      filter: "blur(4px)",
      stagger: 0.05,
      opacity: 0,
    })
      .from(
        paragraphTextLines,
        {
          yPercent: 102,
          duration: 1,
          stagger: 0.1,
          ease: "power2.out",
        },
        "<0.5"
      )
      .from(
        cta,
        {
          opacity: 0,
          duration: 0.5,
          ease: "power2.out",
        },
        "<40%"
      )
      .fromTo(
        videoContainer,
        {
          opacity: 0,
          yPercent: 50,
          duration: 2,
          ease: "power2.out",
        },
        {
          opacity: 1,
          yPercent: 0,
          duration: 2,
          ease: "power2.out",
          onStart: () => {
            setVideoScale();
          },
        },
        "<-100%"
      )
      .from(
        videoContainer,
        {
          width: "100%",
          duration: 2,
          ease: "power2.out",
        },
        "<80%"
      );

    // const returnSvgChildren = (index: number) => {
    //   return heroIcons[index]?.children as HTMLCollectionOf<HTMLElement>;
    // };

    const ease = "expo.inOut";
    // const opacityEase = "expo.out";

    const startHeroIconsTl = () => {
      if (currentIndex === heroIcons.length - 1) {
        gsap.to(heroIcons, {
          opacity: 0,
          delay: 0.5,
          duration: 1.5,
          ease: ease,
          onComplete: () => {
            gsap.set(heroIcons, {
              x: 0,
              y: 0,
            });
            currentIndex = 0;
            startHeroIconsTl();
          },
        });

        return;
      }

      const currentIcon = heroIcons[currentIndex] as HTMLElement;
      const nextIcon = heroIcons[currentIndex + 1] as HTMLElement;
      const distance = flip(currentIcon, nextIcon);

      const tl = gsap.timeline({
        onComplete: () => {
          currentIndex++;
          startHeroIconsTl();
        },
      });

      tl.to(currentIcon, {
        opacity: 1,
        duration: 1,
        ease: ease,
      })
        .to(currentIcon, {
          x: distance.x,
          y: distance.y,
          duration: 1.5,
          ease: ease,
        })
        .to(nextIcon, {
          opacity: 1,
          duration: 1,
          ease: ease,
        })
        .to(currentIcon, {
          opacity: 0,
          duration: 0,
          ease: ease,
        });
    };

    startHeroIconsTl();

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && isFullscreen) {
        if (isVideoOpened) {
          closeVideo();
        }
      }
    });

    videoContainer?.addEventListener("click", (e) => {
      // Check if Video is opened currently
      if (isVideoOpened) {
        closeVideo();
      } else {
        openVideo();
      }
      // check if the play button has not been clicked
      // if (
      //   e.target &&
      //   (e.target as HTMLElement).closest?.('.home_hero_media_controls') !==
      //     playButton &&
      //   isFullscreen
      // ) {
      //   closeVideo()
      //   return
      // }
    });

    const cleanup = () => {
      // playButton?.removeEventListener('click', openVideo)
      window.removeEventListener("keydown", (e) => {
        if (e.key === "Escape" && isFullscreen) {
          closeVideo();
        }
      });
    };

    (element as any)._homeHeroCleanup = cleanup;
  });

  onDestroy(() => {
    if (currentTl) {
      currentTl.kill();
      currentTl = null;
    }

    const cleanup = (element as any)._homeHeroCleanup;
    if (cleanup) {
      cleanup();
    }
  });
}
